import { render, staticRenderFns } from "./NewsFunction.vue?vue&type=template&id=48c65d5b&scoped=true&"
import script from "./NewsFunction.vue?vue&type=script&lang=js&"
export * from "./NewsFunction.vue?vue&type=script&lang=js&"
import style0 from "./NewsFunction.vue?vue&type=style&index=0&id=48c65d5b&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48c65d5b",
  null
  
)

export default component.exports